import { swapEnum } from './swapEnum';

export enum LocaleType {
  Armenian = 'hy-AM',
  Azerbaijani = 'az-AZ',
  Belarusian = 'be-BY',
  Croatian = 'hr-HR',
  Czech = 'cs-CZ',
  English = 'en-US',
  Estonian = 'et-EE',
  French = 'fr-FR',
  Georgian = 'ka-GE',
  Greek = 'el-GR',
  Hungarian = 'hu-HU',
  Kazakh = 'kk-KZ',
  Lithuanian = 'lt-LT',
  Latvian = 'lv-LV',
  Polish = 'pl-PL',
  Portuguese = 'pt-PT',
  Romanian = 'ro-RO',
  Russian = 'ru-RU',
  Slovakian = 'sk-SK',
  Swedish = 'sv-SE',
  Ukrainian = 'uk-UA',
  Danish = 'da-DK',
  Spanish = 'es-ES',
  Finnish = 'fi-FI',
  German = 'de-DE',
  Dutch = 'nl-NL',
  Bulgarian = 'bg-BG',
}

export const LocaleToLanguageMap = swapEnum(LocaleType);

export const LocaleToLocalizedLanguageMap: { [key in LocaleType]: string } = {
  'hy-AM': 'հայ',
  'az-AZ': 'Azərbaycanca',
  'be-BY': 'Беларускай',
  'hr-HR': 'Hrvatski',
  'cs-CZ': 'Čeština',
  'en-US': 'English',
  'et-EE': 'Eesti',
  'fr-FR': 'Français',
  'ka-GE': 'ქართული',
  'el-GR': 'Ελληνικά',
  'hu-HU': 'Magyar',
  'kk-KZ': 'Қазақ',
  'lt-LT': 'Lietuvių',
  'lv-LV': 'Latviešu',
  'pl-PL': 'Polski',
  'pt-PT': 'Português',
  'ro-RO': 'Română',
  'ru-RU': 'Русский',
  'sk-SK': 'Slovenčina',
  'sv-SE': 'Svenska',
  'uk-UA': 'Українська',
  'da-DK': 'Dansk',
  'es-ES': 'Español',
  'fi-FI': 'Suomi',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'bg-BG': 'Български',
};
